import type { CSSProperties } from 'react';

/** Место строки в виртуальном списке. Через top, а не transform: transform поднимал каждую строку на свой слой
 *  композитинга, и при прокрутке её пиксели проступали поверх sticky-шапки (по z-index шапка выше, но слои
 *  считаются иначе). */
export const virtualRowStyle = (top: number): CSSProperties => ({ position: 'absolute', top, left: 0, width: '100%' });
